module.exports = __webpack_public_path__ + "img/GP3 Bulgaria Logos OPIC.1ccff8f9.jpg";